
//Main function that call the product data and print the html to the page for the special collection.
function renderProductCards() {
  const cardContainer = $('.boost-pfs-filter-right-col .boost-pfs-filter-products');
  const applyDiscounts = typeof checkDateRange ==='function' && localStorage.getItem("applyDiscount") == 'true' && (checkDateRange() || checkDateRange('enable_vol_dsc')) ? true : false;
  if(typeof specialCollectionItems != 'undefined' && specialCollectionItems.length > 0 && applyDiscounts) {
    const endpoint = boostPFSAppConfig.api.searchUrl;
    const filterParameters = `page=1&limit=20&fuzzy=false`;
    let products = [];
    specialCollectionItems.forEach(element => {
      const [productTitle, productId] = element.split('--');
      const url = `${endpoint}?shop=${shopDomain}&${filterParameters}&q=${productTitle.replace(/-/g,'_').replace(/""/g, '%20')}`;
      products.push(getBoostPFSProducts(url, productId));
    });
    Promise.all(products)
      .then(productsHtml => {
        swapImage();
        eventColorSwatches();
        injectQuickView();
        if(enableCompare) {
          $("body").addClass('compareBar');
          collectionCompare?._init();
        }
        equalHeight();
      })
      .catch(err => {
        cardsStatus = false;
        displayNoDiscountsMessage(cardContainer)
      }).finally(() => {
        const totalItems = document.querySelector('.boost-pfs-filter-right-col .boost-pfs-filter-total-product');
        if(totalItems) totalItems.innerHTML = `${products.length} Results`;
      });
  }else {
    displayNoDiscountsMessage(cardContainer);
  }
}

//Main function that call the product data and print the html to the page for the national collection.
function renderNationalProductCards() {
  if(typeof specialNationalItems == 'undefined' || specialNationalItems.length <= 0) return;
  const endpoint = boostPFSAppConfig.api.searchUrl;
  const filterParameters = `page=1&limit=20&fuzzy=false`;
  let products = [];
  let totalResults = 0;
  specialNationalItems.forEach(element => {
    const [productTitle, productId, variants] = element.split('--');
    const formattedVariants = variants.slice(0, -1);
    const variantsArr = formattedVariants.split(',');
    const url = `${endpoint}?shop=${shopDomain}&${filterParameters}&q=${productTitle.replace(/-/g,'_').replace(/""/g, '%20')}`;
    if(variantsArr.length > 0 && variantsArr[0] !== "") {
      totalResults += variantsArr.length;
      products.push(getBoostPFSProducts(url, productId, variantsArr));
    }
    Promise.all(products)
    .then(productsHtml => {
      swapImage();
      eventColorSwatches();
      injectQuickView(true);
      equalHeight();
    })
    .catch(err => {
      cardsStatus = false;
    })
    .finally(() => {
      const totalItems = document.querySelector('.boost-pfs-filter-right-col .boost-pfs-filter-total-product');
      if(totalItems) totalItems.innerHTML = `${totalResults} Results`;
    });
  });
}
// recently viewed
function renderRecentlyViewedCards() {
  let productsViewed = kGetCookieArray('recentproducts');
  const endpoint = boostPFSAppConfig.api.searchUrl;
  const filterParameters = `page=1&limit=20&fuzzy=false`;
  let products = [];
  if(productsViewed.length > 0) {    
    productsViewed = productsViewed.reverse();
    productsViewed.forEach((element, index) => {
      const [handle, productTitle, productId] = element.split('--');
      const url = `${endpoint}?shop=${shopDomain}&${filterParameters}&q=${productTitle.replace(/-/g,'_').replace(/""/g, '%20')}`;
      let tpl = $('#recent-item-tpl').html().replace('%order%',index);
      let tpl_mobile = $('#recent-item-tpl-mobile').html().replace('%order%',1);
      if($(window).width() <= 425){
        products.push(getBoostPFSProducts(url, productId,[],$('#recent-container'),tpl_mobile));
      }else{
        products.push(getBoostPFSProducts(url, productId,[],$('#recent-container'),tpl));
      }
    });
    Promise.all(products)
      .then(productsHtml => {
        $('#recent-title').show();
        swapImage();
        eventColorSwatches();
        equalHeightViewed();
        if($(window).width() <= 425){
          let calcSlide = productsViewed.length > 1 ? $(window).width() / 278 : 1;
          $('#recent-container').slick({
            arrows: true,
            dots: false,
            infinite: false,
            autoplay: false,
            speed: 600,
            rtl: theme.rtl,
            slidesToShow: calcSlide,
            slidesToScroll: 1,
            variableWidth: false
          });
        }
      })
      .catch(err => {
        cardsStatus = false;
      })
  }
}


//Boost PFS function for search product data and get the html template of collection cards.
async function getBoostPFSProducts(url, productId, variantsArr = [], container = null, tpl = null) {
  const variantsArrLength = variantsArr.length === 0 ? 1 : variantsArr.length;
  const cardContainer = container ? container : $('.boost-pfs-filter-right-col .boost-pfs-filter-products');
  try {
    const boostPFSRequest = await fetch(url);
    if (!boostPFSRequest.ok) throw new Error('404 - Request not found');
    const data = await boostPFSRequest.json();
    const productData = data.products.find(product => product.id == productId);
    for(let i = 0; i < variantsArrLength; i++) {
      const cardHtml = ProductGridItem.prototype.compileTemplate(productData, variantsArr[i], tpl);
      cardContainer.append(cardHtml);
    }
    return true;
  }catch(err) {
    console.error(err);
  }
  return false;
}
function displayNoDiscountsMessage($wrapper) {
  const htmlMsg = `<p class="today-special-no-results">Nothing today, check back soon! In the meantime, <a class="link" href="/collections">shop collections</a>.</p>`;
  const pageWrapper = $('#PageContainer');
  pageWrapper.addClass('special-collection-no-results');
  $wrapper.empty();
  $wrapper.append(htmlMsg);
}
//Include the images on the cards
function swapImage() {
  if (!Utils.isMobile()) {
    if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
      boostPFSThemeConfig.custom.active_image_swap == true) {
      var dataSrcSetFlipImg = '',
        dataSrcFlipImg = '',
        flipImageAlt = '',
        dataSizes = 'auto',
        dataWidths = '',
        boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
        html = '';

      $(".boost-pfs-filter-product-item").each(function () {
        var productItemSelector = $(this);
        var imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image');

        if (typeof imgSelector.data('img-flip-src') != 'undefined' &&
          imgSelector.data('img-flip-src') != '') {
          dataSrcFlipImg = imgSelector.data('img-flip-src');
          dataSrcSetFlipImg = imgSelector.data('img-flip-srcset');
          flipImageAlt = imgSelector.attr('alt');
          dataWidths = imgSelector.data('widths');
          html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
            'data-srcset="' + dataSrcSetFlipImg + '" ' +
            'data-src="' + dataSrcFlipImg + '" ' +
            'data-widths="[' + dataWidths + ']" ' +
            'data-sizes="' + dataSizes + '" ' +
            'src="' + boostPFSImgDefaultSrc + '" ' +
            'alt="' + flipImageAlt + '" />';

          productItemSelector.find('.boost-pfs-filter-product-item-image-link').append(html);
        }
      });
    }
  }
}
//Include the color swatches on the product cards
function eventColorSwatches() {
  $('.grid__item .swatches li').click(function (e) {
    let swatchImage = $(this).find('span').data('img');
    let imageBox = $(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
    let previweImageBox = $(this).parents('.boost-pfs-filter-product-item-inner').find('.swatch-preview-image');
    $(imageBox).attr({ srcset: swatchImage });
    if(swatchImage.length){
        $(previweImageBox).css("visibility",'hidden');
      var colorlist = $(this).parents('.swatches').children(".swatch");
      $(colorlist).removeClass("active");
      $(this).addClass("active");
    }
    });
  $('.swatches li ').on("mouseenter", function () {
    let swatchImage = $(this).find('span').data('img');
    let imageBox = $(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
    let previweImageBox = $(this).parents('.boost-pfs-filter-product-item-inner').find('.swatch-preview-image');
    $(imageBox).attr({ srcset: swatchImage });
    if(swatchImage.length){
      $(previweImageBox).css("visibility",'hidden');
    }

  }).on("mouseleave", function () {
    let imageBox = $(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
    let previweImageBox = $(this).parents('.boost-pfs-filter-product-item-inner').find('.swatch-preview-image');
    let featuredImageSrcSet = $(imageBox).data('srcset');
    let activeSwatch =$(this).parents('.swatches').children(".swatch.active");
    if(activeSwatch.length){
      swatchImage = activeSwatch.find('span').data('img');
      $(imageBox).attr({ srcset: swatchImage });
      $(previweImageBox).css("visibility",'hidden');
    }else if(!$(this).hasClass("active")){
      $(previweImageBox).css("visibility",'visible');
      $(imageBox).attr({ srcset: featuredImageSrcSet });
    }
  })
}
//Inject the quickView button and functionality on the cards.
function injectQuickView(quickViewUrlParam = false) {
  const concatParam = quickViewUrlParam ? '&' : '?'
  const items = $('.boost-pfs-filter-products .boost-pfs-filter-product-item .boost-pfs-filter-product-item-image');
  items.each(function(){ 
    const imgContainer = $(this);
    const imgLink = imgContainer.find('.boost-pfs-filter-product-item-image-link');
    const dataUrl = $(imgLink).attr('data-url');
    const quickviewHtml = `
    <div class="boost-pfs-action-list-wrapper boost-pfs-action-extend">
      <button class="btn quick-view boost-pfs-quickview-btn boost-pfs-filter-button" aria-label="Quick View" data-src="${dataUrl}${concatParam}view=quick_view">
        <span> <i class="ad ad-search-plus-l" aria-hidden="true"></i></span>
      </button>
    </div>`;
    imgContainer.append(quickviewHtml);
  });
}
function equalHeightViewed() {
  let max = 0;
  const windowsWidth = $(window).width();
  const isMobile = windowsWidth < 768;
  const extraSpace = 42 + 8;
  
  const elements = [];
  jQ('#recent-container .boost-pfs-filter-product-bottom-inner').each(function (i, item) {
    jQ(item).css({ 'min-height': null });
    elements.push({
      item,
      h: jQ(item).height(),
      o: Number(jQ(item).closest('.grid__item').css('order')),
    })
  });
  elements.sort((a, b) => a.o - b.o);
  if(isMobile && elements.length > 2) {
    elements.forEach((itemCurrent,index) => {
      if([1,3].includes(index)){
        const itemPrevious = elements[index-1];
        const max = Math.max(itemPrevious.h, itemCurrent.h);
        jQ(itemPrevious.item).css({ 'min-height': (max + extraSpace) });
        jQ(itemCurrent.item).css({ 'min-height': (max + extraSpace) });
      }else if(index == 2 && elements.length == 3) {
        jQ(itemCurrent.item).css({ 'min-height': (itemCurrent.h + extraSpace) });
      }
    });
    
  }else{
    max = elements.map(({h})=>h).reduce((a,b) => {
      return a = Math.max(a, b);
    });
    elements.forEach(({item}) => {
      jQ(item).css({ 'min-height': (max + extraSpace) });
    });
  }
}
//Apply the same height to all cards according to the highest one
function equalHeight(data) {
  var equal_i = -1;
  var equal_els = [];
  var equal_element = null;
  jQ('.boost-pfs-filter-product-item').each(function (i, element) {

    var offsetTop = jQ(element).offset().top;
    if (!equal_element || equal_element.offset().top !== offsetTop) {
      equal_element = jQ(element);
      equal_i++;
    }

    if (!equal_els[equal_i]) {
      equal_els[equal_i] = [];
    }
    equal_els[equal_i].push(element);
  });

  for (var i = 0; i < equal_els.length; i++) {
    var max = 0;
    var maxRatio = 0;
    var iLength = equal_els[i].length;

    for (var j = 0; j < equal_els[i].length; j++) {
      var item = equal_els[i][j];
      var height = jQ(item).find('.boost-pfs-filter-product-bottom-inner').height();
      max = Math.max(max, height);

    }

    jQ(equal_els[i]).find('.boost-pfs-filter-product-bottom-inner').css({ 'min-height': max });

  }

  var aspect_ratio = boostPFSFilterConfig.general.aspect_ratio;

  if (aspect_ratio != 'false') {
    var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

    var widthImage = jQ('.boost-pfs-filter-product-item').width();
    var indexData = 0;

    // For Ratio
    if (aspect_ratio != 'false' && aspect_ratio != 'auto') {
      var heightImage = 0;
      var widthImage = jQ('.boost-pfs-filter-product-item').width();
      if (aspect_ratio != 'false' && aspect_ratio != 'auto' && aspect_ratio != 'other') {
        var ratioWidthHeight = boostPFSThemeConfig.custom.aspect_ratio;
      } else {
        var ratioWidthHeight = '';
      }

      var ratioWidthHeightOther = boostPFSThemeConfig.custom.aspect_ratio_other;
      if (ratioWidthHeightOther == '' && ratioWidthHeight == '') {
        return null;
      } else {
        if (aspect_ratio != 'other') {
          ratioWidthHeight = ratioWidthHeight.split(':');
          ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
          heightImage = widthImage * ratioWidthHeight;
        } else if (ratioWidthHeightOther != '' && aspect_ratio == 'other') {
          ratioWidthHeightOther = ratioWidthHeightOther.split(':');
          ratioWidthHeightOther = parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
          heightImage = widthImage * ratioWidthHeightOther;
        }
      }
      jQ('.boost-pfs-filter-product-item-image-link').css({ 'padding-top': heightImage + 'px' }).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);

    }
  }
}
